import { render, staticRenderFns } from "./YouPlusProduct.vue?vue&type=template&id=9a69c63a&scoped=true"
import script from "./YouPlusProduct.vue?vue&type=script&lang=js"
export * from "./YouPlusProduct.vue?vue&type=script&lang=js"
import style0 from "./YouPlusProduct.vue?vue&type=style&index=0&id=9a69c63a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a69c63a",
  null
  
)

export default component.exports